export default __webpack_public_path__ + "static/media/btn-close.af6d27d8.svg";